import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getVideos = async () => {
  const UserString = localStorage.getItem("user");
    const User = JSON.parse(UserString);
    const id = User.id;
  const response = await axios.get(`${base_url}ppp/${id}/getVideo`);
 
  return response.data;
  
};
const createVideos = async (formData) => {
  const UserString = localStorage.getItem("user");
    const User = JSON.parse(UserString);
    const id = User.id;
  const response = await axios.post(`${base_url}ppp/${id}/addVideo`, formData);
 
  return response.data;
};
const updateVideo = async (News) => {
  const response = await axios.put(
    `${base_url}Video/editVideo/${News.id}`,
    { title: News.NewsData.title , videos: News.NewsData.videos },
    config
  );

  return response.data;
};

const getVideo = async (id) => {
  const response = await axios.get(`${base_url}Video/getById/${id}`, config);

  return response.data;
};


const deleteVideo = async (id) => {
  const UserString = localStorage.getItem("user");
    const User = JSON.parse(UserString);
    const idd = User.id;
  const response = await axios.delete(`${base_url}ppp/${idd}/deleteVideo/${id}`, config);

  return response.data;
};
const VideoService = {
  getVideos,
  createVideos,
  getVideo,
  updateVideo,
  deleteVideo,
};

export default VideoService;
